import React from "react";
import { colorYellow, colorBlack } from "../../utils/css/colors";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { buildPath, routes } from "../../utils/constants/routes";
import { ButtonContainer } from "../Admin/Witnesses/WitnessProfile/witnessProfileStyle";
import {
  DivCenter,
  CloudOne,
  CloudTwo,
  CloudThree,
  CanoImg,
  NotFoundText,
  ButtonSmallWider,
} from "./errorPageStyles";

import Cloud from "../../assets/icons/Cloud.svg";
import manInCano from "../../assets/icons/manInCano.svg";

const ErrorPage = ({ history }) => {
  const { t } = useTranslation();

  const { guestId, role, hostId } = useSelector(
    ({
      // @ts-ignore
      guestsReducer: { guestId },
      // @ts-ignore
      authReducer: { role },
      // @ts-ignore
      hostsReducer: { hostId },
    }) => ({
      guestId,
      role,
      hostId,
    })
  );

  const goToHomePage = () => {
    if (role && role === "guest" && guestId) {
      return history.push(
        buildPath(routes.guestProfile.salon, { id: guestId })
      );
    } else if (role && role === "host" && hostId) {
      return history.push(
        buildPath(routes.hostProfile.salon, { id: hostId })
      );
    } else if (role && role.includes("admin")) {
      return history.push("/admin");
    } else {
      return history.push("/");
    }
  };

  const goToPreviousPage = () => history.goBack();

  return (
    <DivCenter>
      <CloudOne src={Cloud} alt="notfound" />
      <CloudTwo src={Cloud} alt="notfound" />
      <CloudThree src={Cloud} alt="notfound" />
      <CanoImg src={manInCano} alt="notfound" />
      <NotFoundText>
        {history.location.state === "errorBoundary"
          ? t("errorPage.errorBoundaryMessage")
          : t("errorPage.pageNotFoundError")}
      </NotFoundText>
      <ButtonContainer>
        <ButtonSmallWider
          isFontBold
          colorType={colorYellow}
          colorProps={colorBlack}
          width={7}
          isBold
          onClick={goToHomePage}
          applyShadow
        >
          {t("errorPage.toHomePage")}
        </ButtonSmallWider>
        <ButtonSmallWider
          isFontBold
          colorType={colorYellow}
          colorProps={colorBlack}
          width={7}
          isBold
          onClick={goToPreviousPage}
          applyShadow
        >
          {t("errorPage.goBack")}
        </ButtonSmallWider>
      </ButtonContainer>
    </DivCenter>
  );
};

export default ErrorPage;
